import { defineComponent as _defineComponent } from 'vue'
import {computed} from "vue";

type vBannerProps = {
  bannerType: "info" | "warning" | "danger" | "minimal"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'vBanner',
  props: {
    bannerType: { default: "info" }
  },
  setup(__props: any) {

const props = __props as { bannerType: "info" | "warning" | "danger" | "minimal" };



const bannerClass = computed(
  () => `${props.bannerType} alert-${props.bannerType} border border-${props.bannerType}`
);

return { __sfc: true,props, bannerClass }
}

})